import { useEffect } from 'react';

export function useServiceWorkerVersionCheck() {
  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
        navigator.serviceWorker.controller.postMessage({
          type: 'CHECK_VERSION_AND_CLEAR_CACHE',
          data: {}
        });
      }
    }
  }, []);
}
